module.exports = "<nv-react-component component=\"LearningCatalogModalHeader\"></nv-react-component>";